import startCase from 'lodash/startCase';

/**
 * Maps allocation type to human-readable labels.
 * Keyed by the uppercase string representation of the allocation type enum,
 * so it works for both Java and Python enums.
 */
export const ALLOCATION_TYPE_LABEL_MAP: Record<string, string> = {
    US_DIRECT_STOCKS: 'U.S. Personalized Indexing',
    US_EQUITY_ETF: 'U.S. Equity ETF',
    DEVELOPED_EQUITY_ETF: 'Developed Equity ETF',
    EMERGING_EQUITY_ETF: 'Emerging Equity ETF',
    LEVERED_BOND_ETF: 'Levered Bond ETF',
    CASH_EQUIVALENTS: 'Cash Equivalents',
    SHORT_TERM_TREASURIES_3M: '3-Month Treasuries',
    SHORT_TERM_TREASURIES_1Y: '1-Year Treasuries',
    BOND_LADDER_2Y: '2-Year Bonds',
    BOND_LADDER_5Y: '5-Year Bonds',
    BOND_LADDER_7Y: '7-Year Bonds',
    BOND_LADDER_10Y: '10-Year Bonds',
    BOND_LADDER_20Y: '20-Year Bonds',
    BOND_LADDER_30Y: '30-Year Bonds',
    CUSTOM_ASSET: 'Custom Asset',
    ENHANCED_TREASURIES: 'Enhanced Treasuries',
    HEDGED_EQUITY: 'Hedged Equity',
    PAYDAY_BOND: 'Payday Bonds',
    CONVICTION: 'Convictions',
    NON_CONFORMING: 'Non-Conforming',
};

export const getAllocationTypeLabel = (allocationType: string): string =>
    ALLOCATION_TYPE_LABEL_MAP[allocationType.toUpperCase()] ?? startCase(allocationType.toLowerCase());
